import React from 'react'
import styles from './createCurrency.module.sass'
import CurrencyInfo from './CurrencyInformation'
import CurrencyAction from './CurrencyAction'
import { ToastContainer } from 'react-toastify'

const CreateCurrency = ({isChanged, setIsChanged}) => {
  

  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
          <CurrencyInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default CreateCurrency